import { Component, OnInit, Input } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { iHttpPaginatedResponse } from 'src/app/interfaces/iHttpPaginatedResponse';

@Component({
  selector: 'app-bs-table',
  templateUrl: './bs-table.component.html',
  styleUrls: ['./bs-table.component.scss']
})
export class BsTableComponent implements OnInit {
  @Input('paginatedData') paginatedData:Subject<iHttpPaginatedResponse>;
  @Input('columns') columns;
  
  public dataSource: iHttpPaginatedResponse;
  public noData=false;
  public loadingData = true;
  constructor() { }

  ngOnInit() {
    this.paginatedData.subscribe(iHttpPaginatedData=>{
      this.noData = false;
      if(iHttpPaginatedData!=null && iHttpPaginatedData.data.length==0){
        this.noData = true;
      }
      else if(iHttpPaginatedData!=null){
        this.dataSource =iHttpPaginatedData;
        this.loadingData = false;
        console.log(this.dataSource);
      }
    })
  }

}
